import React from "react";

import { LuCalculator, LuWrench } from "react-icons/lu";
import SNCalculator from "./SNCalculator";
import { MODULE_TOOLS, MODULE_NOE_CALCULATOR } from "variables/constants";
import Roulette from "./roulette/Roulette";
import { displayIcon } from "variables/icons";

const toolsRoutes = [	
	{
	    name: "Tools",
	    layout: "/console",
	    path: "#",
	    icon: displayIcon("LuWrench", "icon-item"),
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: 0,
	    children: [
			{
				name: "SN Calculator",
				layout: "/console",
				path: "sn-calculator",
				icon: displayIcon("LuCalculator", "icon-item"),
				component: <SNCalculator />,
				isMainMenu:true,
				level:3,
				moduleId: 0,
			},
			{
				name: "Roulette",
				layout: "/console",
				path: "roulette",
				icon: displayIcon("CreditCardOutlined", "icon-item"),
				component: <Roulette />,
				isMainMenu:true,
				level:3,
				moduleId: 0,
			},
		],
  	},
	
]

export default toolsRoutes;